<template>
  <section id="devapp-attachments">
    <h3 class="devapp-detail-label">{{ attachmentCount }}</h3>
    <div class="document-list">
      <ul v-for="doc in documents" :key="doc.docReferenceId">
        <li> <a v-bind:href="createURL(doc.filePath)"
               target="_blank"
               v-on:keyup.esc="exitDocList()"
               v-bind:title="doc.documentName"
               v-bind:aria-label="doc.documentName  + ' ' + fileExtension(doc.filePath)  + ' ' + doc.fileSize  + ' ' + $t('search.form.linkIsExternal')">{{ doc.documentName }}</a>
          ({{ fileExtension(doc.filePath) }} - {{ doc.fileSize }}) 
          <span aria-hidden="true" class="icon is-medium">
            <svg aria-hidden="true" 
              focusable="false" 
              data-prefix="fas" 
              data-icon="external-link-alt" 
              role="img" 
              xmlns="http://www.w3.org/2000/svg" 
              viewBox="0 0 512 512" class="svg-inline--fa fa-external-link-alt fa-w-16">
              <path fill="currentColor" d="M432,320H400a16,16,0,0,0-16,16V448H64V128H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V336A16,16,0,0,0,432,320ZM488,0h-128c-21.37,0-32.05,25.91-17,41l35.73,35.73L135,320.37a24,24,0,0,0,0,34L157.67,377a24,24,0,0,0,34,0L435.28,133.32,471,169c15,15,41,4.5,41-17V24A24,24,0,0,0,488,0Z" class=""></path>
            </svg>
          </span>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  name: 'devapp-attachments',
  properties: {
    devapp: Object
  },
  data: function() {
    return {
      docs: {}
    }
  },
  computed: {
    curDevapp: function() {
      return this.$store.state.currentDevapp
    },
    documents: function() {
      const devapp = this.$store.state.currentDevapp
      if (devapp && devapp.devAppDocuments && devapp.devAppDocuments.length) {
        return devapp.devAppDocuments;
      }
      return [];
    },
    attachmentCount: function() {
      let numAttachments = 0
      const devapp = this.$store.state.currentDevapp
      if (devapp && devapp.devAppDocuments && devapp.devAppDocuments.length) {
        numAttachments = devapp.devAppDocuments.length
      }
      if (numAttachments === 1) {
        return `${numAttachments} ${this.$t('devapp.details.docs.count')}`
      }
      return `${numAttachments} ${this.$t('devapp.details.docs.countPlural')}`
    }
  },
  methods: {
    createURL: function(filename) {
      return  process.env.VUE_APP_DEV_APP_WEBCAST_URL + filename;
    },
    exitDocList: function() {
      let el = document.getElementById('btn-close')
      
      if( el == null) {
        el = document.getElementById('btn-search')
      }
      el.focus()
    },
    fileExtension: function(filename) {
      let ext = '';
      if( filename.lastIndexOf(".") > 0 ) {
        ext = filename.substring(filename.lastIndexOf(".") + 1 ).toUpperCase();
      }
      return ext;
    }
  }
}
</script>

<style lang="scss">
@import '@/scss/app.scss';

</style>
